import { Button } from '../../../components/Form/Button';
import Google from '../../../components/Logos/Google';

const OAuthButton: React.FC<{
  provider: 'google';
  id: string;
  onClick: () => void;
}> = ({ provider, id, onClick }) => {
  const providerDetails = {
    google: {
      icon: <Google className='h-5 w-5' />,
    },
  };
  return (
    <Button
      type='button'
      id={id}
      variant='outline'
      className='w-full flex items-center justify-center'
      onClick={onClick}
    >
      <label className='sr-only'>Continue with {provider}</label>
      {providerDetails[provider].icon}
    </Button>
  );
};

export default OAuthButton;
